// extracted by mini-css-extract-plugin
module.exports = {"root":"reset-success_root__1RPd4","icon":"reset-success_icon__R-L8W","description":"reset-success_description__3Yw-K","submit":"reset-success_submit__a0zVS"};